module.exports = __webpack_public_path__ + "static/media/DoorDash_Logo.d1909a0a.svg";